import { FC } from 'react';
import { EditableText } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useOffsiteCampaignEditorDispatch } from '../../../context/UseOffsiteCampaignEditorContext';

const StyledSegmentName = styled.div`
  margin-bottom: 1rem;
`;

export interface Props {
  segmentId: string;
  name: string;
}

export const SegmentName: FC<Props> = props => {
  const { t } = useTranslation('campaigns');
  const dispatch = useOffsiteCampaignEditorDispatch();

  const onChange = (name: string) => {
    dispatch({
      type: 'UPDATE_SEGMENT_NAME',
      payload: {
        segmentId: props.segmentId,
        name: name,
      },
    });
  };

  return (
    <StyledSegmentName>
      <EditableText
        ariaLabel={t('campaigns:offsiteEditor.segments.segmentName.label')}
        placeholder={t('campaigns:offsiteEditor.segments.segmentName.placeholder')}
        value={props.name}
        onChange={onChange}
        spacingBelow={false}
        inputTestId="SegmentNameInput"
      />
    </StyledSegmentName>
  );
};
